
import {Scene} from 'scene';

const Sprite = PIXI.Sprite;
const TextureCache = PIXI.utils.TextureCache;
const BitmapText = PIXI.extras.BitmapText;

export default class SceneTerms extends Scene {
    constructor() {
        super();

        this._pageTextures = [
            TextureCache['res/term_pages/page_0.png'],
            TextureCache['res/term_pages/page_1.png'],
            TextureCache['res/term_pages/page_2.png'],
            TextureCache['res/term_pages/page_3.png'],
            TextureCache['res/term_pages/page_4.png'],
        ];
        this.currentPageSprite = new Sprite(this._pageTextures[0]);
        this.addChild(this.currentPageSprite);

        this._currentTermPageId = 0;

        const termsUIPanel = new Sprite(TextureCache['res/terms_panel_ui.png']);
        termsUIPanel.position.set(0, 980);
        this.addChild(termsUIPanel);

        this.termsTerminalLabel = new BitmapText('', {font: "terminal_white_font", align: "left"});
        this.termsTerminalLabel.position.set(1390, 57);
        termsUIPanel.addChild(this.termsTerminalLabel);
    }

    nextPage() {
        if (this._currentTermPageId < 4) {
            this._currentTermPageId++;
            this.currentPageSprite.texture = this._pageTextures[this._currentTermPageId];
        }
    };

    prevPage() {
        if (this._currentTermPageId > 0) {
            this._currentTermPageId--;
            this.currentPageSprite.texture = this._pageTextures[this._currentTermPageId];
        }
    };

    isFirstPage() {
        return this._currentTermPageId === 0;
    }

    isLastPage() {
        return this._currentTermPageId === this._pageTextures.length - 1;
    }

    setTerminalId(id) {
        this.termsTerminalLabel.text = id;
    }
}


// WEBPACK FOOTER //
// ./src/terms_scene.es6